import { Button, Card, ControlGroup, Drawer } from "@blueprintjs/core";
import { MediaTag, type MediaTagProps } from "@package/ui-apollo-components";
import { useGetMediaQuery } from "@package/ui-gql/index-data-access";
import { useState } from "react";
import { useAppSelector } from "../../store/store";
import { MediaGrid } from "../Content/panels/media/MediaGridWithToolbar";

type MediaTagSelectorProps = MediaTagProps & {
  disabled?: boolean;
  onSelectMedia: (mediaId?: string) => void;
};

export function MediaTagSelector({
  disabled,
  id,
  onRemoveMedia,
  onSelectMedia,
}: MediaTagSelectorProps) {
  const selectedItemIdMedia = useAppSelector(
    (state) => state.itemGrid.media.selectedItemId,
  );

  const [mediaDrawerOpen, setMediaDrawerOpen] = useState<boolean>(false);

  const { data: dataMediaSelected } = useGetMediaQuery({
    variables: {
      id: selectedItemIdMedia ?? "",
    },
    skip: !selectedItemIdMedia,
  });

  return (
    <ControlGroup fill>
      <MediaTag fill large minimal id={id} onRemoveMedia={onRemoveMedia} />
      <div className="flex-none">
        <Button
          disabled={disabled}
          icon="search"
          intent="primary"
          minimal
          outlined
          onClick={() => setMediaDrawerOpen(true)}
        />
      </div>
      <Drawer
        isOpen={mediaDrawerOpen}
        icon="media"
        title="Select a Media File"
        className="bg-slate-100 overflow-auto"
        onClose={() => setMediaDrawerOpen(false)}
      >
        <div className="mx-4 mt-4">
          <MediaGrid showFolderTree={false} />
        </div>
        <div className="m-4">
          <Card>
            <Button
              intent="primary"
              text="Select Media"
              disabled={!dataMediaSelected || !!dataMediaSelected.item?.isDir}
              large
              onClick={() => {
                onSelectMedia(selectedItemIdMedia);
                setMediaDrawerOpen(false);
              }}
            />
          </Card>
        </div>
      </Drawer>
    </ControlGroup>
  );
}
